import React, { useRef, useEffect, useState } from 'react'
import { App, Button, ColorPicker, ConfigProvider, Form, Input, Modal, notification, Popover, Radio, Select, Space, Spin, Steps, Table, Tabs, Tooltip } from 'antd'

import Styles from './ExamineeInfoModal.module.scss'
import ViewExamineeFileModal from '../ViewExamineeFileModal'
import { deleteExamineeTag, findApplyFieldRule, getExamDictData, getExamineeApplyLog, getExamPositionTemplate, getPositionInfo, getTagList, insertCheckerCheckTag, updateExamineeTag } from '../../common/request'
import ResponseCode from '../../common/response-code'
import {
  buildExamineeRuleFormValues,
  getRequiredUploadFileFields,
  isApplyFilesUploadComplete
} from '../../common/apply-field-rule'
import { updateDictInfo } from '../../store/slice/dict-slice'
import { updateOrgTagList } from '../../store/slice/org-slice'
import { useDispatch, useSelector } from 'react-redux'
import { generateFileUrl, getUid } from '../../plugins/utils'
import eventBus from '../../plugins/events'
import { CheckOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons'
import ChsiReportVerificationSummary from './ChsiReportVerificationSummary'
import SchoolTagSummary from './SchoolTagSummary'
import { isInputSuggestEnabled } from '../../common/inputSuggestConstants'

function ExamineeInfo (props) {
  const systemFields = ['applyDateTime', 'reviewer', 'reviewDate']
  const dispatch = useDispatch()
  const { modal } = App.useApp()
  const [addTagForm] = Form.useForm()
  const dictInfo = useSelector(state => state.dict.dictInfo)
  const envInfo = useSelector(state => state.env.envInfo)
  const orgTagList = useSelector(state => state.org.orgTagList)
  const selectedExam = useSelector(state => state.examInfo.selectedExam)
  const viewExamineeFileModalRef = useRef()
  const [basicFormItems, setBasicFormItems] = useState([])
  const [filePhotoFormItem, setFilePhotoFormItem] = useState([])
  const [registerFormItems, setRegisterFormItems] = useState([])
  const [positionFormItems, setPositionFormItems] = useState([])
  const [positionInfo, setPositionInfo] = useState({})
  const [examineeStatusTableData, setExamineeStatusTableData] = useState([])
  const [operatingRecord, setOperatingRecord] = useState([])
  const [currentViewFile, setCurrentViewFile] = useState({})
  const [initDataLoading, setInitDataLoading] = useState(true)
  const [fileTableDataSource, setFileTableDataSource] = useState([])
  const [sideBarItems, setSideBarItems] = useState([])
  const [tagOptions, setTagOptions] = useState([])
  const [selectedExamineeTag, setSelectedExamineeTag] = useState([])
  const [tagItemChanged, setTagItemChanged] = useState(false)
  const [initExamineeTagId, setInitExamineeTagId] = useState(undefined)
  const [addTagModalVisible, setAddTagModalVisible] = useState(false)
  const [addTagLoading, setAddTagLoading] = useState(false)
  const [applyFieldRuleList, setApplyFieldRuleList] = useState([])
  const [applyFieldRulesLoaded, setApplyFieldRulesLoaded] = useState(false)

  useEffect(() => {
    if (!props.modalVisible || !selectedExam?.id) {
      return
    }

    setApplyFieldRulesLoaded(false)
    findApplyFieldRule({ examId: String(selectedExam.id) }).then(res => {
      if (res.code === ResponseCode.success) {
        setApplyFieldRuleList(res.data?.applyFieldRuleList || [])
      } else {
        setApplyFieldRuleList([])
      }
      setApplyFieldRulesLoaded(true)
    }).catch(() => {
      setApplyFieldRuleList([])
      setApplyFieldRulesLoaded(true)
    })
  }, [props.modalVisible, selectedExam?.id])

  useEffect(() => {
    if (props.examineeItem?.checkTag?.id) {
      setSelectedExamineeTag([props.examineeItem?.checkTag?.id])
      setInitExamineeTagId(props.examineeItem?.checkTag?.id)
    } else {
      setSelectedExamineeTag([])
      setInitExamineeTagId(undefined)
    }
  }, [props.examineeItem])

  useEffect(() => {
    setTagOptions(orgTagList?.map(tag => {
      return {
        ...tag,
        label: tag.name,
        value: tag.id
      }
    }))

    eventBus.addListener('reloadOperatingRecord', eventListener)

    return () => {
      eventBus.removeListener('reloadOperatingRecord', eventListener)
    }
  }, [props.modalVisible, orgTagList])

  useEffect(() => {
    if (initExamineeTagId === selectedExamineeTag[0]) {
      setTagItemChanged(false)
    } else {
      setTagItemChanged(true)
    }
  }, [selectedExamineeTag, initExamineeTagId])

  useEffect(() => {
    setBasicFormItems([])
    setFilePhotoFormItem([])
    setRegisterFormItems([])
    setPositionFormItems([])
    responseTransform()
  }, [props.templateField])

  useEffect(() => {
    if (props.modalVisible) {
      const initExamStatus = [
        { label: '报名序号', ...getApplyNo() },
        { label: '基本信息', ...getBasicInfoStatus() },
        { label: '个人照片', ...getSelfImageUploadStatus() },
      ]

      if (props.templateField.fileFields?.length > 0) {
        initExamStatus.push({ label: '资料证件', ...getFileUploadStatus() })
      }

      initExamStatus.push({ label: '审核状态', ...getAuditStatus() })

      if (selectedExam?.payType === 1) {
        initExamStatus.push({ label: '缴费状态', ...getPaymentStatus() })
      }

      setExamineeStatusTableData(initExamStatus)
    }
  }, [selectedExam, filePhotoFormItem, props.templateField, props.applyInfo, props.modalVisible, applyFieldRuleList, applyFieldRulesLoaded, positionInfo])

  useEffect(() => {
    if (props.templateField.fileFields?.length > 0) {
      setSideBarItems([
        {
          key: 'fileData',
          label: '证件资料',
          children: (
            <div className={Styles.fileListWrap}>{
              fileTableDataSource?.map(field => {
                return field.fileList?.length > 0 && (
                  <div className="mt-2" key={ field.fieldCode }>
                    <div className={ Styles.fileType }>{ field.fieldName }</div>
                    <div className={ Styles.fileValue }>{ field.fileList?.map(file => {
                      return (<Tooltip title={ file.fileName } placement="left" key={ file.filePath }>
                        <div className={ Styles.fileName } onClick={ showExamineeFile.bind(this, file) }>{ file.fileName }</div>
                      </Tooltip>)
                    }) }</div>
                  </div>
                )
              })
            }</div>
          )
        },
        {
          key: 'operationLogs',
          label: '操作记录',
          forceRender: false,
          children: (
            <div className={ Styles.operatingRecord }>
              <Steps
                className="w-100"
                progressDot
                current={ operatingRecord.length }
                direction="vertical"
                items={ getOperatingRecordSteps(operatingRecord) }
              />
            </div>
          )
        }
      ])
    } else {
      setSideBarItems([{
        key: 'operationLogs',
        label: '操作记录',
        forceRender: false,
        children: (
          <div className={ Styles.operatingRecord }>
            <Steps
              className="w-100"
              progressDot
              current={ operatingRecord.length }
              direction="vertical"
              items={ getOperatingRecordSteps(operatingRecord) }
            />
          </div>
        )
      }])
    }
  }, [operatingRecord, props.templateField, fileTableDataSource])

  useEffect(() => {
    getExamineeOperatingRecord(props.examineeItem?.id || props.examineeItem?.applyInfoId)
    getPositionInfoAction(props)
    getPositionTemplate()
    setFileTableDataSource(props.templateField.fileFields?.map(field => {
      if (props.applyInfo.applyFiles && props.applyInfo.applyFiles[field.fieldCode]) {
        return {
          ...field,
          fileList: JSON.parse(props.applyInfo.applyFiles[field.fieldCode]).map(file => {
            return file
          })
        }
      } else {
        return []
      }
    }) || [])
  }, [props.templateField, props.modalVisible, props.examineeItem, props.applyInfo])

  useEffect(() => {
      viewExamineeFileModalRef.current.hideModal()
  }, [props.examineeItem])

  const eventListener = (id) => {
    // getExamineeOperatingRecord(id)
  }

  const getExamineeOperatingRecord = (id) => {
    getExamineeApplyLog({ applyInfoId: id }).then(res => {
      if (res.code === ResponseCode.success) {
        setOperatingRecord(res.data)
      } else {
        Modal.error({
          title: '错误',
          content: res.msg
        })
      }
    }).catch(err => {
      Modal.error({
        title: '错误',
        content: '网络错误，查询考生操作记录失败'
      })
    })
  }

  const getPositionInfoAction = (props) => {
    getPositionInfo({ id: props.applyInfo.positionId }).then(res => {
      if (res.code === ResponseCode.success) {
        setPositionInfo(res.data)
      }
    })
  }

  const responseTransform = () => {
    props.templateField.fields?.forEach((item) => {
      if (item.fieldJoinSelect) {
        getDictInfo(item.fieldJoinSelect)
      }
      if (item.fieldFromType == 2 && item.fieldFilling == 2 && !systemFields.includes(item.fieldAuto)) {
        setBasicFormItems((pre) => {
          return pre.concat(item)
        })
      }
      if (item.fieldFromType == 2 && item.fieldFilling == 1) {
        if (item.fieldType == 6) {
          setFilePhotoFormItem(pre => {
            return pre.concat(item)
          })
        } else if (item.fieldType == 7) {
          if (item.selectContent && item.selectContent != '') {
            let array = item.selectContent.split('|')
            item.tableHead = []
            array.forEach(function (text) {
              item.tableHead.push({
                title: text.split('-')[0],
                key: text.split('-')[0],
                width: text.split('-')[1] === 't' ? '100px' : 'auto',
                dataIndex: text.split('-')[0],
                render: (text) => {
                  if (text.length > 50) {
                    return (<>

                      <Popover content={ <div style={ { maxWidth: 500 } }>{ text }</div> }>
                        <div>{ text.substring(0, 50) + '...' }<span className="text-primary">更多</span></div>
                      </Popover>
                    </>)
                  } else
                    return text
                }
              })
            })
          }
          setRegisterFormItems(pre => {
            return pre.concat(item)
          })
        } else {
          setRegisterFormItems(pre => {
            return pre.concat(item)
          })
        }
      }

      // if (item.fieldFromType == 1) {
      //   setPositionFormItems(pre => {
      //     return pre.concat(item)
      //   })
      // }
    })
    setInitDataLoading(false)
  }

  const getPositionTemplate = () => {
    getExamPositionTemplate({ id: selectedExam.id }).then(res => {
      if (res.code === ResponseCode.success) {
        if (res.data.indexTemplateSet) {
          setPositionFormItems(res.data.indexTemplateSet.filter(item => {
            return !item.examSelection && !['siteCode', 'levelCode', 'majorCode', 'p_zprs', 'qttj'].includes(item.fieldCode)
          }))
        }
      } else {
        Modal.error({
          title: '错误',
          content: res.msg,
          centered: true
        })
      }
    }).catch(() => {
      Modal.error({
        title: '网络错误',
        content: '查询职位字段失败',
        centered: true
      })
    })
  }

  const getDictInfo = (fieldJoinSelect) => {
    if (!dictInfo[fieldJoinSelect]) {
      getExamDictData({ dictCode: fieldJoinSelect }).then(res => {
        if (res.code === ResponseCode.success) {
          dispatch(updateDictInfo({ dictKey: fieldJoinSelect, dictValue: res.data }))
        } else {
          Modal.error({
            title: '错误',
            centered: true,
            content: res.msg
          })
        }
      }).catch((err) => {
        console.error(err)
        Modal.error({
          title: '网络错误',
          centered: true,
          content: '查询字段类型字典失败'
        })
      })
    }
  }

  const getApplyNo = () => {
    return {
      message: props.examineeItem.applyNo || props.examineeItem.examineesNumber,
      className: 'text-success'
    }
  }

  const getBasicInfoStatus = () => {
    const basicInfoKeyMap = {
      xm: 'name',
      sfzh: 'idCard',
      lxdh: 'phone'
    }
    const status = basicFormItems.every(item => {
      return basicInfoKeyMap[item.fieldCode]
        ? props.applyInfo[basicInfoKeyMap[item.fieldCode]]
        : props.applyInfo.applyInfo[item.fieldCode]
    })

    return {
      message: status ? '已填写' : '未填写',
      className: status ? 'text-success' : 'text-danger'
    }
  }

  const getSelfImageUploadStatus = () => {
    const needPhoto = filePhotoFormItem.length > 0
    const status = props.applyInfo.applyInfo?.grzp
    let message = '无需上传'
    let className = 'text-primary'

    if (needPhoto) {
      message = status ? '已上传' : '未上传'
      className = status ? 'text-success' : 'text-danger'
    }

    return {
      message: message,
      className: className
    }
  }

  const getFileUploadStatus = () => {
    const allFileFields = props.templateField?.fileFields || []

    if (allFileFields.length === 0) {
      return {
        message: '无需上传文件',
        className: 'text-primary'
      }
    }

    const formValues = buildExamineeRuleFormValues({
      applyInfo: props.applyInfo,
      positionInfo
    })
    const requiredFields = getRequiredUploadFileFields({
      allFileFields,
      ruleList: applyFieldRuleList,
      rulesLoaded: applyFieldRulesLoaded,
      formValues
    })

    if (requiredFields.length === 0) {
      return {
        message: '无必传文件',
        className: 'text-primary'
      }
    }

    const uploaded = isApplyFilesUploadComplete({
      requiredFields,
      applyFiles: props.applyInfo?.applyFiles
    })

    return {
      message: uploaded ? '已上传' : '未上传',
      className: uploaded ? 'text-success' : 'text-danger'
    }
  }

  const getAuditStatus = () => {
    let message = ''
    let className = ''

    switch (props.applyInfo.saveStatus) {
      case -2:
        message = '撤回'
        className = 'text-warning'
        break
      case -1:
        message = '审核未通过' + '(未通过原因: ' + (props.applyInfo.noApprovedReason || '智能审核不通过') + ')'
        className = 'text-danger'
        break
      case 0:
        message = '尚未提交审核'
        className = 'text-primary'
        break
      case 1:
        message = '未审核'
        className = 'text-warning'
        break
      case 2:
        message = '已通过'
        className = 'text-success'
        break
    }

    return {
      message: message,
      className: className
    }
  }

  const getPaymentStatus = () => {
    let message = ''
    let className = ''

    switch (props.applyInfo.payStatus) {
      case -1:
        message = '申请退款成功'
        className = 'text-primary'
        break
      case 0:
        message = '未缴费'
        className = 'text-warning'
        break
      case 1:
        message = '已缴费'
        className = 'text-success'
        break
      case 2:
        message = '不需缴费'
        className = 'text-primary'
        break
      case 3:
        message = '贫困生免费'
        className = 'text-primary'
        break
    }

    return {
      message: message,
      className: className
    }
  }

  const generateExamineeInfo = (list, loading) => {
    if (loading) {
      return <Spin spinning={ loading }>
        <div style={ { height: 300 } }></div>
      </Spin>
    } else {
      return list.filter(item => {
        return item.fieldCode !== 'bmxh'
      }).map((item) => {
        return (
          <div className={ Styles.infoItem } key={ item.fieldCode }>
            <div className={ Styles.infoLabel }>{ item.fieldName }</div>
            <div className={ Styles.infoValue }>
              { getFieldValue(item) }
              {
                isInputSuggestEnabled(item)
                  ? <SchoolTagSummary schoolTag={ props.applyInfo?.schoolTag } inline />
                  : null
              }
            </div>
          </div>
        )
      })
    }
  }

  const generatePositionInfo = (list) => {
    return list.map((item) => {
      return (
        <div className={ Styles.infoItem } key={`${item.fieldName}-${item.fieldCode}`}>
          <div className={ Styles.infoLabel }>{ item.fieldName }</div>
          <div className={ Styles.infoValue }>{ positionInfo[item.fieldCode] }</div>
        </div>
      )
    })
  }

  const generateExamineePhoto = (photoForm) => {
    if (photoForm.length > 0 && props.applyInfo.applyInfo?.grzp) {
      return <img className={ Styles.userPhoto } src={ generateFileUrl(envInfo, props.applyInfo.applyInfo?.grzp) }/>
    } else {
      return <></>
    }
  }

  const getOperatingRecordSteps = () => {
    return operatingRecord.map((item, index) => {
      return {
        title: item.operateTime,
        description: <div dangerouslySetInnerHTML={ {
          __html: item.logInfo
            + (item.noApprovedReason
              ? `<div class="text-danger">
                <span>不通过原因：</span>
                <span>${ item.noApprovedReason }</span>
              </div>`
              : '')
            + (item.autoCheckResults?.filter(checkItem => {
              return !checkItem.pass
            }).map(checkItem => {
              return `<div>
              <span style="color: #1677ff;">${ checkItem.fieldName }</span>
              <span style="color: #f5222d;">不满足报考条件</span>
            </div>`
            }).join('') || '')
        } } key={ index }></div>
      }
    })
  }

  const showExamineeFile = (file) => {
    setCurrentViewFile(file)
    viewExamineeFileModalRef.current.showModal()
  }


  const getExamineeApplyStatus = (list, loading) => {
    if (loading) {
      return <Spin spinning={ loading }>
        <div style={ { height: 300 } }></div>
      </Spin>
    } else {
      return list.map((item, index) => {
        return (
          <div className={ Styles.infoItem } key={ index }>
            <div className={ Styles.infoLabel }>{ item.label }</div>
            <div className={ item.className }>{ item.message }</div>
          </div>
        )
      })
    }
  }

  const generateTable = (item) => {
    return (
      <ConfigProvider componentSize={ 'small' }>
        <Table
          style={{ maxWidth: 680 }}
          scroll={{
            x: 650
          }}
          className={ Styles.infoValueTable}
          bordered
          columns={ item.tableHead }
          dataSource={ props.applyInfo.applyInfo[item.fieldCode] }
          rowKey={ () => {
            return `${ item.fieldCode }${ getUid() }`
          } }
          pagination={ false }
        ></Table>
      </ConfigProvider>
    )
  }

  const getFieldValue = (field) => {
    let label = ''
    if (field.fieldFromType === '1') {
      label = props.applyInfo[field.fieldCode] || props.applyInfo.applyInfo[field.fieldCode]
    }

    if (field.fieldFromType === '2' && field.fieldFilling === '2') {
      label = props.applyInfo[field.fieldAuto] || props.applyInfo.applyInfo[field.fieldCode]
    }

    if (field.fieldFromType === '2' && field.fieldFilling === '1') {
      switch (field.fieldType) {
        case '4':
          label = getDictLabel(field) || ''
          break
        case '7':
          label = generateTable(field) || ''
          break
        case '9':
          label = getTreeDataLabel(field) || ''
          break
        case '12':
          label = getRegionDataLabel(field) || ''
          break
        default:
          label = props.applyInfo.applyInfo[field.fieldCode] || ''
      }
    }

    return label
  }

  const getDictLabel = (field) => {
    return dictInfo[field.fieldJoinSelect]?.find(item => {
      return item.dictValue === props.applyInfo.applyInfo[field.fieldCode]
    })?.dictLabel
  }

  const getTreeDataLabel = (field) => {
    const data = props.applyInfo.applyInfo[field.fieldCode]
    return (data && data[data.length - 1].split(',')[1]) || ''
  }

  const getRegionDataLabel = (field) => {
    const regionData = props.applyInfo.applyInfo[field.fieldCode]
    let label = ''
    if (regionData?.province) {
      label += regionData.province.name
    }
    if (regionData?.city) {
      label += regionData.city.name
    }
    if (regionData?.district) {
      label += regionData.district.name
    }
    return label
  }

  const deleteExamineeTagAction = () => {
    deleteExamineeTag({  applyId: props.applyInfo.id }).then(res => {
      if (res.code === ResponseCode.success) {
        notification.success({
          title: '操作成功',
          message: '已删除标签',
        })
        setInitExamineeTagId(undefined)
        props.uploadList?.()
      } else {
        modal.error({
          title: '错误',
          content: res.msg
        })
      }
    }).catch(err => {
      console.error(err)
      modal.error({
        title: '错误',
        content: '网络错误，删除标签失败'
      })
    })
  }

  const beforeUpdateExamineeTag = () => {
    if (selectedExamineeTag.length > 0) {
      updateExamineeTagAction()
    } else {
      deleteExamineeTagAction()
    }
  }

  const updateExamineeTagAction = () => {
    const currentTag = orgTagList.find(item => item.id === selectedExamineeTag[0])

    updateExamineeTag({
      applyId: props.applyInfo.id,
      ...currentTag
    }).then(res => {
      if (res.code === ResponseCode.success) {
        notification.success({
          message: '更新成功'
        })
        setInitExamineeTagId(currentTag.id)
        props.uploadList?.()
      } else {
        modal.error({
          title: '错误',
          content: res.msg
        })
      }
    }).catch(err => {
      console.error(err)
      modal.error({
        title: '错误',
        content: '网络错误，更新标签失败'
      })
    })
  }

  const refreshOrgTagList = () => {
    return getTagList({
      orgId: selectedExam.orgId,
      status: 1
    }).then(res => {
      if (res.code === ResponseCode.success) {
        dispatch(updateOrgTagList({
          tagList: res.data || []
        }))
        return res.data || []
      }
      return Promise.reject(new Error(res.msg))
    })
  }

  const handleAddTag = () => {
    addTagForm.setFieldsValue({
      name: '',
      color: '#1677ff',
      status: 1
    })
    setAddTagModalVisible(true)
  }

  const hideAddTagModal = () => {
    setAddTagModalVisible(false)
    addTagForm.resetFields()
  }

  const handleAddTagOk = () => {
    addTagForm.validateFields().then(values => {
      let color = values.color
      if (color && typeof color !== 'string') {
        color = color.toHexString()
      }

      const tagId = getUid()
      setAddTagLoading(true)
      insertCheckerCheckTag({
        orgId: selectedExam.orgId,
        id: tagId,
        name: values.name,
        color,
        status: values.status ?? 1
      }).then(res => {
        if (res.code === ResponseCode.success) {
          notification.success({
            message: '添加标签成功'
          })
          hideAddTagModal()
          return refreshOrgTagList().then(() => tagId)
        }
        modal.error({
          title: '错误',
          content: res.msg
        })
        return null
      }).then(newTagId => {
        if (newTagId) {
          setSelectedExamineeTag([newTagId])
          setTagItemChanged(true)
        }
      }).catch(err => {
        console.error(err)
        modal.error({
          title: '错误',
          content: err?.message || '网络错误，添加标签失败'
        })
      }).finally(() => {
        setAddTagLoading(false)
      })
    }).catch(() => {})
  }

  return (
    <div className={ 'w-100 d-flex justify-content-between' }>
      <div className={ Styles.infoWrap }>
        <div className={ Styles.infoScrollWrap }>
          { generateExamineePhoto(filePhotoFormItem) }
          <div className={ Styles.infoTitle }>考生报考状态</div>
          <div>
            { getExamineeApplyStatus(examineeStatusTableData, initDataLoading) }
            <ChsiReportVerificationSummary
              verification={ props.applyInfo?.chsiReportVerification }
              onViewDetail={ props.onViewChsiDetail }
            />
          </div>
          <div className={ Styles.infoTitle }>职位信息</div>
          {/*<div>{ generateExamineeInfo(positionFormItems, initDataLoading) }</div>*/}
          <div>{ generatePositionInfo(positionFormItems) }</div>
          <div className={ Styles.infoTitle }>考生基本信息</div>
          <div>{ generateExamineeInfo(basicFormItems, initDataLoading) }</div>
          <div className={ Styles.infoTitle }>考生报名信息</div>
          <div>{ generateExamineeInfo(registerFormItems, initDataLoading) }</div>
        </div>
      </div>
      <div className={ Styles.operatingRecordWrap }>
        <div>
          <div className={ Styles.operatingRecordTitle }>
            考生标签
            <Button size="small" className="text-primary px-0" icon={ <PlusOutlined /> } type="text" onClick={handleAddTag}>添加标签</Button>
          </div>
          <div className={ Styles.tagWrap }>
            <Select
              value={ selectedExamineeTag }
              className="w-100"
              mode="multiple"
              maxCount={ 1 }
              showSearch
              optionFilterProp="label"
              filterOption={ (input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.trim().toLowerCase())
              }
              options={ tagOptions }
              placeholder="选择考生标签"
              optionRender={(option, info) => {
                return (<div className="d-flex align-center">
                  <div className="mr-2" style={{ width: 20, height: 20, background: option.data.color, borderRadius: 4 }}></div>
                  <div>{ option.data.name }</div>
                </div>)
              }}
              tagRender={(tagProps) => {
                const currentTag = orgTagList.find(item => item.id === tagProps.value)

                return (
                  <div
                    className="mr-1 d-flex align-center"
                    style={{
                      background: `${currentTag?.color}47`,
                      color: '#222',
                      border: `1px solid ${currentTag?.color}`,
                      fontSize: 12,
                      padding: '0 4px',
                      borderRadius: 2
                    }}
                  >
                    { currentTag?.name }
                    <CloseOutlined
                      className="ml-2"
                      style={{
                        fontSize: 10,
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        setSelectedExamineeTag(pre => {
                          return pre.filter(item => item !== tagProps.value)
                        })
                      }}
                    />
                  </div>
                )
              }}
              onChange={(value) => {
                setSelectedExamineeTag(value)
              }}
            ></Select>
            {
              tagItemChanged
              ? (
                <Space className="ml-2">
                  <Button
                    className="p-0"
                    size="small"
                    type="link"
                    danger
                    onClick={() => {
                      if (initExamineeTagId) {
                        setSelectedExamineeTag([initExamineeTagId])
                      } else {
                        setSelectedExamineeTag([])
                      }
                    }}
                  ><CloseOutlined /></Button>
                  <Button
                    className="p-0"
                    size="small"
                    type="link"
                    onClick={() => {
                      beforeUpdateExamineeTag()
                    }}
                  >
                    <CheckOutlined />
                  </Button>
                </Space>
              )
              : <></>
            }
          </div>
        </div>
        <Tabs defaultActiveKey="fileData" items={ sideBarItems }></Tabs>
      </div>

      <ViewExamineeFileModal
        ref={ viewExamineeFileModalRef }
        fileItem={ currentViewFile }
      ></ViewExamineeFileModal>

      <Modal
        title="添加标签"
        width={ 500 }
        open={ addTagModalVisible }
        confirmLoading={ addTagLoading }
        onOk={ handleAddTagOk }
        onCancel={ hideAddTagModal }
        destroyOnClose
      >
        <Spin spinning={ addTagLoading }>
          <Form
            form={ addTagForm }
            className="my-4"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 16 }}
            initialValues={ {
              name: '',
              color: '#1677ff',
              status: 1
            } }
          >
            <Form.Item
              label="标签名称"
              name="name"
              rules={ [{ required: true, message: '请输入标签名称' }] }
            >
              <Input placeholder="请输入标签名称"></Input>
            </Form.Item>
            <Form.Item
              label="标签颜色"
              name="color"
              rules={ [{ required: true, message: '请选择标签颜色' }] }
            >
              <ColorPicker></ColorPicker>
            </Form.Item>
            <Form.Item
              label="标签状态"
              name="status"
            >
              <Radio.Group options={ [{ label: '禁用', value: 0 }, { label: '启用', value: 1 }] }></Radio.Group>
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    </div>
  )
}

export default ExamineeInfo
